<div class="toggle-container" [class.deactivated]="!active" [class.partial]="partial">
    <div class="on-half" [class.selected]="boolValue" (click)="toggleOn()">
        <span>{{localize(langSection.Term, langText.On)}}</span>
    </div>
    <div class="partial-selected" (click)="toggle()">
        <span class="ups-icon ups-icon-swap-horiz"></span>
    </div>
    <div class="off-half" [class.selected]="!boolValue" (click)="toggleOff()">
        <span>{{localize(langSection.Term, langText.Off)}}</span>
    </div>
</div>